import React from "react";
import { Apple, Play, Smartphone } from "lucide-react";
import { ComingSoon } from "@/components/common";
import { PLAY_STORE_URL, APP_STORE_URL, openExternal } from "@/lib/appLinks";

export const Saved = () => <ComingSoon title="Saved" sub="Items you've bookmarked to buy later." />;
export const Offers = () => <ComingSoon title="Offers" sub="Send and manage offers on buy-now items." />;

export const Download = () => (
  <div className="fade-up" style={{ maxWidth: 720, margin: "0 auto", textAlign: "center", padding: "12px 0" }} data-testid="download-page">
    <div style={{ display: "inline-flex", width: 64, height: 64, borderRadius: 18, background: "var(--gold-soft)", color: "var(--brand)", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
      <Smartphone size={30} />
    </div>
    <h1 style={{ fontSize: 30, fontWeight: 800, color: "var(--brand)" }}>Get the SouqStream app</h1>
    <p className="ss-muted" style={{ fontSize: 15, marginTop: 8, maxWidth: 520, marginInline: "auto" }}>
      Sell live, bid in real-time auctions, shop Buy-Now drops and support fundraisers — all from your phone.
    </p>
    <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 24 }}>
      <button
        className="dl-store"
        onClick={() => openExternal(PLAY_STORE_URL)}
        data-testid="download-googleplay"
      >
        <Play size={22} /><span><small>Get it on</small><b>Google Play</b></span>
      </button>
      {APP_STORE_URL ? (
        <button className="dl-store" onClick={() => openExternal(APP_STORE_URL)} data-testid="download-appstore">
          <Apple size={24} /><span><small>Download on the</small><b>App Store</b></span>
        </button>
      ) : (
        <div className="dl-store" style={{ opacity: 0.6, cursor: "default" }} data-testid="download-appstore-soon">
          <Apple size={24} /><span><small>Coming soon to the</small><b>App Store</b></span>
        </div>
      )}
    </div>
  </div>
);
